<template>
  <c-q-btn
    id="btn-delete-focused-institutional"
    propBtnLabel="Excluir"
    :propBtnFunction="onDeleteFocusedInstitutionalBtnClick"
    :propBtnTransparent="true"
    :propBtnSize="props.propBtnSize"
  />
</template>

<script setup lang="ts">
import { EnumMultipleSingleMode, EnumButtonSizes } from '@/enums/enums';
import { usePagesUtilStore } from '@/stores/pagesUtilStore';
import { useInstitutionalStore } from '@/stores/institutionalStore'; // ✅

const pagesUtilStore = usePagesUtilStore();
const institutionalStore = useInstitutionalStore(); // ✅

const props = defineProps({
  propBtnSize: {
    type: String as () => keyof typeof EnumButtonSizes,
    required: true,
    default: EnumButtonSizes.SMALL
  },
  propInstitutionalId: { // ✅ recebe o id
    type: Number,
    required: false
  }
});

const onDeleteFocusedInstitutionalBtnClick = () => {
  pagesUtilStore.modalDeleteInstitutionalConfirmationMode = EnumMultipleSingleMode.SINGLE;

  // ✅ salva o id no detail para o modal usar
  institutionalStore.institutionalDetail = { id: props.propInstitutionalId } as any

  pagesUtilStore.showModalDeleteInstitutionalConfirmation = true;
};
</script>

<style scoped>
/* sem estilos específicos */
</style>